/**
 |--------------------------------------------------------------------------
 | ACTIVITY : Vue-Router Routes
 |--------------------------------------------------------------------------
 */
const reports = [

    {
        path: '/sunset/reports/note-stats/user/:userid/:type/:start/:end', component: require('pages/sunset/reports/notestats/user_totals.vue').default,
        props: true,
        name: 'reports_notestats_user_totals',
        meta: {requiresAuth: true, title: "Summary of user note stats", icon: "fas fa-chart-line"}
    },
    {
        path: '/sunset/reports/note-stats/notes/user/:userid/:type/:start/:end', component: require('pages/sunset/reports/notestats/user_notes_detailed.vue').default,
        props: true,
        name: 'reports_notestats_user_notes_detailed',
        meta: {requiresAuth: true, title: "Summary of user notes", icon: "fas fa-chart-line"}
    },
    {
        path: '/sunset/reports/note-stats/notes/:type/:start/:end', component: require('pages/sunset/reports/notestats/global_notes_detailed.vue').default,
        props: true,
        name: 'reports_notestats_global_notes_detailed',
        meta: {requiresAuth: true, title: "Summary of global note stats", icon: "fas fa-chart-line"}
    },
    {
        path: '/sunset/reports/note-stats/user/select_criteria', component: require('pages/sunset/reports/notestats/user_select_criteria.vue').default,
        name: 'reports_notestats_user_select_criteria',
        meta: {requiresAuth: true, title: "Select user based report criteria", icon: "fas fa-chart-line"}
    },
    {
        path: '/sunset/reports/note-stats/totals/:type/:start/:end', component: require('pages/sunset/reports/notestats/global_totals.vue').default,
        props: true,
        name: 'reports_notestats_global_totals',
        meta: {requiresAuth: true, title: "Summary of global note stats", icon: "fas fa-chart-line"}
    },
    {
        path: '/sunset/reports/note-stats/leaderboard/select_criteria', component: require('pages/sunset/reports/notestats/leaderboard_criteria.vue').default,
        name: 'reports_notestats_leaderboard_criteria',
        meta: {requiresAuth: true, title: "Select leaderboard based report criteria", icon: "fas fa-chart-line"}
    },
    {
        path: '/sunset/reports/note-stats/leaderboard/:type/:start/:end', component: require('pages/sunset/reports/notestats/leaderboard.vue').default,
        props: true,
        name: 'reports_notestats_leaderboard',
        meta: {requiresAuth: true, title: "Leaderboard", icon: "fas fa-chart-line"}
    },
    {
        path: '/sunset/reports/note-stats/global/select_criteria', component: require('pages/sunset/reports/notestats/global_select_criteria.vue').default,
        name: 'reports_notestats_global_select_criteria',
        meta: {requiresAuth: true, title: "Select global report criteria", icon: "fas fa-chart-line"}
    },
    {
        path: '/reports/profit-and-loss', component: require('pages/reports/Profit_and_loss.vue').default,
        name: 'reports_profit_and_loss',
        meta: {requiresAuth: true, title: "Profit and Loss", icon: "fas fa-chart-line"}
    },
    {
        path: '/reports/cashflow', component: require('pages/reports/Cashflow.vue').default,
        name: 'reports_cashflow',
        meta: {requiresAuth: true, title: "Cashdlow", icon: "fas fa-chart-line"}
    },
];
export default reports;
